import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import React, { ReactNode, useEffect } from 'react'

// Sadece production'da veya açıkça belirtildiğinde takip başlatılsın
// Geliştirme ortamındaki (localhost) veriler karıştırılmasın
if (typeof window !== 'undefined' && import.meta.env.VITE_POSTHOG_KEY) {
  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
    // SPA navigation tracking
    capture_pageview: false, // React Router ile manuel handle edeceğiz
    autocapture: true,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: ".sensitive-data",
    }
  })
}

export function AnalyticsProvider({ children }: { children: ReactNode }) {
  // Posthog key yoksa, children doğrudan dönsün
  if (!import.meta.env.VITE_POSTHOG_KEY) {
    return <>{children}</>
  }
  
  return (
    <PostHogProvider client={posthog}>
      {children}
    </PostHogProvider>
  )
}
